module.exports = __webpack_public_path__ + "images/74502dcaa0e85d19065ca6475b00603e41f8d337e630ce99673fec6125f594ea.svg";